(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbb-close"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SLOT = '[data-dbb-kaching-slot]';
  const BAR = '.kaching-bundles__bar';
  const CONTAINER = '.kaching-bundles__bar-container';
  const boundSlots = new WeakSet();
  let busy = false;
  const frame = () => new Promise((resolve) => requestAnimationFrame(resolve));
  const route = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;

  const addRow = (parent, className, html) => {
    let row = parent.querySelector(`.${className}`);
    if (!row) {
      row = document.createElement('div');
      row.className = className;
      row.innerHTML = html;
      parent.appendChild(row);
    }
    return row;
  };

  const enhanceBar = (bar, index) => {
    const container = bar.querySelector(CONTAINER);
    const main = bar.querySelector('.kaching-bundles__bar-main');
    if (!container || !main) return;
    bar.dataset.dbbQuantity = String(index === 0 ? 1 : 2);
    const image = bar.querySelector('.kaching-bundles__bar-image');
    const offerImages = {
      'Kaching-Bundles-offer1_300x300.webp': 'https://cdn.shopify.com/s/files/1/0764/8028/2815/files/Kaching-Bundles-offer1.webp?v=1791512126',
      'Kaching-Bundles-offer2_300x300.webp': 'https://cdn.shopify.com/s/files/1/0764/8028/2815/files/Kaching-Bundles-offer2.webp?v=1791512175'
    };
    if (image) {
      const filename = image.src.split('/').pop().split('?')[0];
      if (offerImages[filename]) {
        const source = `${offerImages[filename]} 1200w`;
        if (image.getAttribute('srcset') !== source) image.setAttribute('srcset', source);
        if (image.getAttribute('sizes') !== '(max-width: 749px) 90vw, 50vw') image.setAttribute('sizes', '(max-width: 749px) 90vw, 50vw');
      }
    }
    const pricing = bar.querySelector('.kaching-bundles__bar-pricing');
    if (pricing) addRow(pricing, 'dbb-kaching-price', index === 0
      ? '<s class="dbb-kaching-before-price" aria-label="Before $60">$60</s><strong>$45</strong><small>one-time</small>'
      : '<strong>$78</strong><small>$39 each</small>');
    addRow(main, 'dbb-kaching-product-row', index === 0
      ? '1× DayBlock Sleep Mask' : '2× DayBlock Sleep Masks');
    addRow(container, 'dbb-kaching-value-row', index === 0
      ? '<span>Combined value <s>$72</s></span><strong>SAVE $27</strong>'
      : '<span>Combined value <s>$174</s></span><strong>SAVE $96</strong>');
    bar.querySelectorAll('.kaching-bundles__free-gift').forEach((gift) => {
      const text = gift.querySelector('.kaching-bundles__free-gift__text')?.textContent || '';
      const kind = /shipping/i.test(text) ? 'shipping'
        : /earplug|soundblock/i.test(text) ? 'earplugs'
        : /bracelet|daycharge/i.test(text) ? 'bracelet' : '';
      if (kind && gift.dataset.dbbGift !== kind) gift.dataset.dbbGift = kind;
    });
    const variants = bar.querySelector('.kaching-bundles__bar-variants');
    variants?.querySelectorAll('.kaching-bundles__bar-variant').forEach((variant, variantIndex) => {
      if (!variant.querySelector('.dbb-kaching-color-label')) {
        const label = document.createElement('span');
        label.className = 'dbb-kaching-color-label';
        label.textContent = index === 0 ? 'CHOOSE YOUR COLOR' : `MASK ${variantIndex + 1} COLOR`;
        variant.prepend(label);
      }
    });
    if (!container.querySelector('.dbb-kaching-checkout')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dbb-kaching-checkout';
      button.dataset.defaultText = index === 0 ? 'CHOOSE SINGLE — $45' : 'CHOOSE DUO — $78';
      button.textContent = button.dataset.defaultText;
      container.appendChild(button);
    }
    const error = addRow(container, 'dbb-kaching-checkout-error', '');
    error.setAttribute('role', 'alert');
  };

  const onCheckout = async (event, slot) => {
    const button = event.target.closest('.dbb-kaching-checkout');
    if (!button || !slot.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    if (busy) return;
    const bar = button.closest(BAR);
    const block = bar?.closest('kaching-bundles-block');
    const error = bar?.querySelector('.dbb-kaching-checkout-error');
    const report = (message) => { if (error) error.textContent = message; };
    if (!block || typeof block.items !== 'function' || typeof block.validateItemSelection !== 'function') {
      report('Please refresh the page and try again.');
      return;
    }
    busy = true;
    let committed = false;
    slot.querySelectorAll('.dbb-kaching-checkout').forEach((control) => { control.disabled = true; });
    button.textContent = 'TAKING YOU TO CHECKOUT…';
    report('');
    try {
      const barId = bar.getAttribute('data-deal-bar-id');
      if (!barId) throw new Error('Please refresh the page and try again.');
      if (block.selectedDealBarId !== barId) {
        block.selectedDealBarId = barId;
        await frame();
        await frame();
      }
      if (block.selectedDealBarId !== barId) throw new Error('Please select your set and try again.');
      const validation = block.validateItemSelection();
      if (!validation?.valid) throw new Error('Please choose an available color for each mask.');
      if (typeof block.rotateBundleNonce === 'function') block.rotateBundleNonce();
      const items = block.items();
      if (!Array.isArray(items) || !items.length || items.some((item) => !item.id || !(item.quantity > 0))) {
        throw new Error('Please select an available set and try again.');
      }
      const maskIds = new Set((block.product?.variants || []).map((variant) => String(variant.id)));
      if (!maskIds.size) throw new Error('Please refresh the page and try again.');
      const maskQuantity = items.filter((item) => maskIds.has(String(item.id)))
        .reduce((sum, item) => sum + Number(item.quantity), 0);
      if (maskQuantity !== Number(bar.dataset.dbbQuantity)) {
        throw new Error('Please select your set and try again.');
      }
      const metadata = (item) => {
        try { return JSON.parse(item.properties?.__kaching_bundles || '{}'); }
        catch { return {}; }
      };
      const dealIds = new Set(items.map((item) => metadata(item).deal).filter(Boolean));
      if (!dealIds.size) throw new Error('Please refresh the page and try again.');
      const cartResponse = await fetch(route('cart.js'), {
        credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('Your previous selection could not be checked. Please try again.');
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items)) throw new Error('Your previous selection could not be checked. Please try again.');
      const updates = {};
      cart.items.forEach((item) => {
        const bundle = metadata(item);
        if (dealIds.has(bundle.deal) && (maskIds.has(String(item.variant_id)) || bundle.gift)) {
          if (!item.key) throw new Error('Your previous selection could not be replaced. Please refresh and try again.');
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length) {
        const replaced = await fetch(route('cart/update.js?kaching_bundles=true'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!replaced.ok) throw new Error('Your previous selection could not be replaced. Please try again.');
        const remaining = await replaced.json();
        if (!Array.isArray(remaining.items) || remaining.items.some((item) => {
          const bundle = metadata(item);
          return dealIds.has(bundle.deal) && (maskIds.has(String(item.variant_id)) || bundle.gift);
        })) throw new Error('Your previous selection could not be replaced. Please try again.');
      }
      let response;
      try {
        response = await fetch(route('cart/add.js?kaching_bundles=true'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
      } catch {
        throw new Error('The connection was interrupted. Check your cart before trying again.');
      }
      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(problem.description || 'This set could not be added. Please check availability and try again.');
      }
      committed = true;
      window.location.assign(route('checkout'));
    } catch (problem) {
      report(committed ? 'Your set is in the cart. Please continue to checkout.' : problem.message);
      busy = false;
      slot.querySelectorAll('.dbb-kaching-checkout').forEach((control) => { control.disabled = false; });
      button.textContent = button.dataset.defaultText;
    }
  };

  const resetCheckout = () => {
    busy = false;
    document.querySelectorAll(`${SLOT} .dbb-kaching-checkout`).forEach((button) => {
      button.disabled = false;
      button.textContent = button.dataset.defaultText;
    });
  };
  const bindPurchaseNavigation = () => {
    const closing = document.querySelector('.dbb-close-offer');
    const sticky = document.querySelector('[data-dbb-sticky-purchase]');
    if (!closing || !sticky || sticky.dataset.dbbBound) return;
    sticky.dataset.dbbBound = 'true';
    const target = closing.querySelector('.dbb-close-choose');
    if (!target) return;
    target.id = `${closing.id}-sets`;
    document.querySelectorAll('main .dbb-btn, .dbb-navigation__cta').forEach((link) => {
      if (closing.contains(link)) return;
      link.setAttribute('href', `#${target.id}`);
      link.removeAttribute('aria-disabled');
    });
    sticky.querySelector('a').setAttribute('href', `#${target.id}`);
    const jump = (event) => {
      const control = event.target.closest('main .dbb-btn, .dbb-navigation__cta, [data-dbb-sticky-purchase] a');
      if (!control || closing.contains(control) || !closing.isConnected) return;
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    };
    document.addEventListener('click', jump, true);
    const updateSticky = () => {
      const rect = closing.getBoundingClientRect();
      sticky.hidden = !(window.scrollY > 80 && rect.top >= window.innerHeight);
    };
    const intersection = new IntersectionObserver(updateSticky);
    intersection.observe(closing);
    window.addEventListener('pageshow', updateSticky);
    window.addEventListener('resize', updateSticky);
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
    const removed = new MutationObserver(() => {
      if (closing.isConnected && sticky.isConnected) return;
      document.removeEventListener('click', jump, true);
      window.removeEventListener('pageshow', updateSticky);
      window.removeEventListener('resize', updateSticky);
      window.removeEventListener('scroll', updateSticky);
      intersection.disconnect();
      removed.disconnect();
    });
    removed.observe(document.body, { childList: true, subtree: true });
  };
  const boot = (root = document) => {
    bindPurchaseNavigation();
    root.querySelectorAll(SLOT).forEach((slot) => {
      if (boundSlots.has(slot)) return;
      boundSlots.add(slot);
      let scheduled = false;
      const enhance = () => {
        scheduled = false;
        slot.querySelectorAll(BAR).forEach(enhanceBar);
      };
      const observer = new MutationObserver(() => {
        if (scheduled || !slot.isConnected) return;
        scheduled = true;
        requestAnimationFrame(enhance);
      });
      observer.observe(slot, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
      slot.addEventListener('click', (event) => onCheckout(event, slot));
      enhance();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  window.addEventListener('pageshow', resetCheckout);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
